import { createContext, useContext } from "react";
import { ProductAndProjectStateManager } from "./ProductAndProjectStateManager";
export const productAndProjectStateManager = new ProductAndProjectStateManager();
const Context = createContext(productAndProjectStateManager);
export const useProductAndProjectStateManager = () => useContext(Context);
//# sourceMappingURL=useProductAndProjectStateManager.js.map